import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import actions from './actions'
Vue.use(Vuex)
const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters: {
    navModule: state => state.navModule,
    navIndex: state => state.navIndex,
    userRole: state => state.userRole,
    wwContext: state => state.wwContext,
    appEntry: state => state.wwContext.appEntry,
    wwContactUserId: state => state.wwContext.contactUserId,
    wwContactCorpId: state => state.wwContext.contactCorpId,
    wwGroupChatId: state => state.wwContext.groupChatId,
    wwContact: state => state.wwContact,
    cppContact: state => state.cppContact
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js